// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"19af4721","977":"bf864fe6"}[chunkId] + ".chunk.js";
};